import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ChannelConfig" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "itemModal" }
const _hoisted_10 = { class: "dialog-footer" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {ref} from 'vue'
import {usePageModal} from '@/hooks/usePageModal'
import {initEmptyParam} from "@/hooks/useInitParam";
import {useStore} from "@/store";
import {getListData, postData} from "@/service/main/system";
import {ElLoading, ElMessage} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelConfig',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'channelName')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

// 自定义利率
const configureRateDialogVisible = ref(false)
const resourceChange = ref(0)
const repeatRate = ref(0)
const deleteRate = ref(0)
const fixedRateStatus = ref()
const fixedRepeatRate = ref(0)
const fixedDeleteRate = ref(0)
const minTriggerQuantity = ref(0)
const channelId = ref()

const handleConfigureFixedRate = (item: any) => {
  console.log(item)
  configureRateDialogVisible.value = true
  channelId.value = item.id
  resourceChange.value = item.resourceChange
  repeatRate.value = item.repeatChange
  deleteRate.value = item.deleteChange
  fixedRateStatus.value = item.fixedRateStatus.toString()
  fixedRepeatRate.value = item.fixedRepeatRate
  fixedDeleteRate.value = item.fixedDeleteRate
  minTriggerQuantity.value = item.minTriggerQuantity
}

const configureRateTipDialog = async (item: any) => {
  if (item) {

    if (minTriggerQuantity.value < 0) {
      ElMessage({
        message: '最低触发量不能小于0',
        type: 'warning',
      })
      return;
    }

    if (fixedRateStatus.value == 1) {
      if (fixedRepeatRate.value == null || fixedRepeatRate.value == "" || fixedRepeatRate.value == undefined) {
        ElMessage({
          message: '固定重复率不能为空',
          type: 'warning',
        })
        return;
      }

      if (fixedRepeatRate.value < 0) {
        ElMessage({
          message: '固定重复率不能小于0',
          type: 'warning',
        })
        return;
      }

      if (fixedDeleteRate.value == null || fixedDeleteRate.value == "" || fixedDeleteRate.value == undefined) {
        ElMessage({
          message: '固定删除率不能为空',
          type: 'warning',
        })
        return;
      }

      if (fixedDeleteRate.value < 0) {
        ElMessage({
          message: '固定删除率不能小于0',
          type: 'warning',
        })
        return;
      }
    }

    try {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '修改数据中...',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      await postData('/main/customerChannel/setFixedRate', {
        channelId: channelId.value,
        minTriggerQuantity: minTriggerQuantity.value,
        resourceChange: resourceChange.value,
        repeatChange: repeatRate.value,
        deleteChange: deleteRate.value,
        fixedRateStatus: fixedRateStatus.value,
        fixedRepeatRate: fixedRepeatRate.value,
        fixedDeleteRate: fixedDeleteRate.value
      }).then(() => {
        loadingInstance.close()
        configureRateDialogVisible.value = false
        initData()
      })
    } catch (e) {
      configureRateDialogVisible.value = false
    }
  } else {
    configureRateDialogVisible.value = false
  }
}

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageModalRef, defaultInfo, handleNewData] = usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customerChannel",
      onEditBtnClick: handleConfigureFixedRate
    }, {
      resourceChange: _withCtx((scope) => [
        (scope.row.resourceChange != null && scope.row.resourceChange != '' && scope.row.resourceChange != undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.resourceChange) + "%", 1))
          : _createCommentVNode("", true)
      ]),
      repeatChange: _withCtx((scope) => [
        (scope.row.repeatChange != null && scope.row.repeatChange != '' && scope.row.repeatChange != undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.repeatChange) + "%", 1))
          : _createCommentVNode("", true)
      ]),
      deleteChange: _withCtx((scope) => [
        (scope.row.deleteChange != null && scope.row.deleteChange != '' && scope.row.deleteChange != undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.deleteChange) + "%", 1))
          : _createCommentVNode("", true)
      ]),
      fixedRateStatus: _withCtx((scope) => [
        (scope.row.fixedRateStatus == 0 )
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "否"))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "是"))
      ]),
      fixedRepeatRate: _withCtx((scope) => [
        (scope.row.fixedRepeatRate != null && scope.row.fixedRepeatRate != '' && scope.row.fixedRepeatRate != undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.fixedRepeatRate) + "%", 1))
          : _createCommentVNode("", true)
      ]),
      fixedDeleteRate: _withCtx((scope) => [
        (scope.row.fixedDeleteRate != null && scope.row.fixedDeleteRate != '' && scope.row.fixedDeleteRate != undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.fixedDeleteRate) + "%", 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_dialog, {
        modelValue: configureRateDialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((configureRateDialogVisible).value = $event)),
        title: "设置固定利率",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (configureRateTipDialog(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (configureRateTipDialog(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "最低触发量：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: minTriggerQuantity.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((minTriggerQuantity).value = $event)),
                    type: "number",
                    placeholder: "请输入最低触发量"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "资源量折扣：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: resourceChange.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((resourceChange).value = $event)),
                    type: "number",
                    placeholder: "折扣为0-100之间,例如：95为九五折"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "调整重复率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: repeatRate.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatRate).value = $event)),
                    type: "number",
                    placeholder: "请输入调整的重复率",
                    disabled: fixedRateStatus.value == 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("%")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "调整删除率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: deleteRate.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deleteRate).value = $event)),
                    type: "number",
                    placeholder: "请输入调整的删除率",
                    disabled: fixedRateStatus.value == 1
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("%")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "固 定 利 率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: fixedRateStatus.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fixedRateStatus).value = $event)),
                    "active-value": "1",
                    "inactive-value": "0"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "固定重复率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "fixed_repeat",
                    modelValue: fixedRepeatRate.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fixedRepeatRate).value = $event)),
                    type: "number",
                    placeholder: "请输入固定重复率",
                    disabled: fixedRateStatus.value == 0,
                    min: 0
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("%")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "固定删除率：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "fixed_delete",
                    modelValue: fixedDeleteRate.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fixedDeleteRate).value = $event)),
                    type: "number",
                    placeholder: "请输入固定删除率",
                    disabled: fixedRateStatus.value == 0
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("%")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})